import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, ArrowRight, Loader2, ShieldCheck } from 'lucide-react';
import { Button, TextField } from '@dopomogai/ui';

type EmailGateProps = {
  onSubmit: (email: string) => Promise<void>;
  isLoading: boolean;
};

export const EmailGate: React.FC<EmailGateProps> = ({ onSubmit, isLoading }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setError('Please enter a valid business email.');
      return;
    }
    await onSubmit(email);
  };

  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      className="max-w-md mx-auto w-full bg-white border-2 border-slate-900 rounded-2xl shadow-[8px_8px_0_0_#10b981] overflow-hidden p-8"
    >
      <div className="flex justify-center mb-6">
        <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center border-2 border-slate-100">
          <Lock size={32} className="text-emerald-600" />
        </div>
      </div>

      <div className="text-center mb-8">
        <h3 className="text-2xl font-black text-slate-900 mb-2 uppercase tracking-tight">
          Analysis Complete
        </h3>
        <p className="text-slate-600 font-medium">
          We have generated your custom infrastructure blueprint. Enter your email to unlock the results.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <TextField
            label="Business Email"
            placeholder="founder@company.com"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setError(''); }}
            disabled={isLoading}
            error={error}
          />
        </div>

        <Button
          fullWidth
          variant="primary"
          size="lg"
          text={isLoading ? "Unlocking..." : "Unlock Blueprint"}
          icon={isLoading ? <Loader2 className="animate-spin" /> : <ArrowRight />}
          disabled={isLoading}
          onClick={() => {}} // Handled by form
          type="submit"
        />
      </form>

      <div className="mt-6 flex justify-center items-center gap-2 text-[10px] text-slate-400 font-bold uppercase tracking-widest">
        <ShieldCheck size={12} />
        <span>No Spam. Secure Delivery.</span>
      </div>
    </motion.div>
  );
};